<template>
  <div>
    <!--Stats cards-->
    <div class="row">
      <div class="col-lg-12 col-sm-12" v-for="stats in statsCards">
        <stats-card>
          <div class="icon-big text-left" :class="`icon-${stats.type}`" slot="header">
            <img src="static/img/logo_brasal_c.png" alt="Brasal" class="logo_brasal_a">
          </div>
          <div class="numbers" slot="content">
          <img src="static/img/logo.png" alt="Avaliação de Desempenho" class="logo_ad_ra">

          </div>
          <div class="stats" slot="footer">
            <div class="row">
              <div class="col-xs-12 comp">

              A avaliação de desempenho por competências tem um papel fundamental dentro das empresas: identificar colaboradores que precisam ser desligados ou desenvolvidos e destacar pontos positivos e talentos na organização.<br/><br/>

Ela é utilizada pelas empresas para analisar o desempenho de cada colaborador, determinando se ele é o mais qualificado para sua função e os possíveis pontos de melhorias em sua performance.<br/><br/>

Normalmente essa qualificação dos colaboradores é determinada pelos seus conhecimentos, habilidades e atitudes (CHA), ou seja, suas competências. Mas se vamos falar em competências, primeiro precisamos saber quais são os diferentes tipos de competências. São elas:<br/><br/>
<ul>
<li><b>Técnicas</b><br/> são os conhecimentos e habilidades adquiridos por uma pessoa através da educação formal e não formal, como treinamentos, cursos, palestras etc.<br/><br/></li>
<li><b>Comportamentais</b><br/> são as atitudes e os comportamentos de uma pessoa em ambiente social ou empresarial, definidos por sua personalidade.<br/><br/></li>
<li><b>Gerenciais</b><br/> são as competências essenciais que um gestor deve ter para conseguir gerir o desenvolvimento de si, dos colaboradores e da empresa.<br/><br/></li>
<li><b>Organizacionais</b><br/> são todas as competências que formam a identidade e o diferencial competitivo de uma corporação.<br/><br/></li>
</ul>

Fazer a avaliação de desempenho é importante para uma empresa conhecer a si mesma e aos seus colaboradores. Ao fazer essa avaliação baseada em competências, uma organização pode alcançar resultados melhores. Neste artigo, nós vamos te mostrar o que é avaliação de desempenho por competências e quais são os benefícios dela para uma empresa.<br/><br/>


<h4>O que é Avaliação de Desempenho por Competências?</h4><br/>
Avaliação de Desempenho por Competências é uma análise sistemática do desempenho de cada colaborador em uma empresa. Ela mensura a contribuição de cada pessoa a partir da relação entre o desempenho profissional e as competências essenciais para cumprir sua função.<br/><br/>

Sabemos que tudo aquilo que não pode ser avaliado, não pode ser mensurado e, se não pode ser mensurado, não pode ser melhorado. Além da avaliação de desempenho por competências, dentro do ambiente empresarial existem outros tipos de avaliação de desempenho, como a avaliação de desempenho por objetivos.<br/><br/>

No passado a avaliação de desempenho por objetivos era muito presente dentro das empresas. Este modelo visava avaliar o desempenho dos colaboradores por meio do atingimento de suas metas ou objetivos previamente acordados com o gestor.<br/><br/>


Atualmente, muitas empresas estão aderindo à avaliação de desempenho por competências, pois ela mensura o desempenho de cada colaborador junto com as competências que são desejadas pelas organizações.<br/><br/>

Neste formato, avalia-se não somente as metas e objetivos, mas também as competências técnicas, comportamentais e gerenciais, além de encontrar as necessidades de desenvolvimento dos colaboradores. Quando aplicada em uma empresa, a avaliação de desempenho por competências maximiza a produtividade e o desenvolvimento de cada colaborador, proporcionando alinhamento com os objetivos organizacionais.<br/><br/>

Portanto, a avaliação de desempenho por competências cumpre um papel essencial no planejamento estratégico de pessoas em uma empresa por ser mais abrangente. <br/><br/>


              </div>
            </div>


          </div>
        </stats-card>

      </div>




    </div>






  </div>
</template>
<script>
  import CircleChartCard from 'src/components/UIComponents/Cards/CircleChartCard.vue'
  import StatsCard from 'src/components/UIComponents/Cards/StatsCard.vue'
  import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
  import Loading from 'src/components/Dashboard/Layout/LoadingMainPanel.vue'
  import PProgress from 'src/components/UIComponents/Progress.vue'

  // const WorldMap = () => ({
  //   component: import('./../Maps/WorldMap.vue'),
  //   loading: Loading,
  //   delay: 200
  // })

  export default {
    components: {
      StatsCard,
      ChartCard,
      CircleChartCard,
      // WorldMap,
      PProgress
    },
    /**
     * Chart data used to render stats, charts. Should be replaced with server data
     */
    data () {
      return {
        statsCards: [
          {
            type: 'warning',
            icon: 'ti-briefcase',
            title: 'Negócios',
            value: '8',
            compText1: 'Persuasão'
          }
        ],
        earningsChart: {
          data: {
            labels: ['Jan', 'Feb', 'Mar', 'April', 'May', 'June'],
            series: [
              [230, 340, 400, 300, 570, 500, 800]
            ]
          },
          options: {
            showPoint: false,
            lineSmooth: true,
            height: '210px',
            axisX: {
              showGrid: false,
              showLabel: true
            },
            axisY: {
              offset: 40,
              showGrid: false
            },
            low: 0,
            high: 'auto',
            classNames: {
              line: 'ct-line ct-green'
            }
          }
        }

      }
    }
  }

</script>
<style>
.grade_comp{
  text-align:right;
}
.logo_brasal_a{
  width:35px;
  margin-top: -8px;
}
.col-xs-5 {
    width: 40%;
}
.col-xs-7 {
    width: 58%;
}
.logo_ad_ra{
 margin-top:10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Evaluation/About.vue